export const overlayRootStyles = `
  html, body, #root {
    background: transparent !important;
    background-color: transparent !important;
  }
`;
